import { OrderDetail } from '@interfaces/OrderTypes';
import { useGetCommerce } from '@pages/Commerce/hooks/commerce';
import { generatePdf, generateDoublePdf } from '@utils/printUtils';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useDetailedOrders } from './orders';

interface PrintOrderProps {
  orderId: string;
  detailedOrder?: OrderDetail;
}

export const usePrintOrder = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { commerce } = useGetCommerce();
  const { getOrder } = useDetailedOrders();

  const printOrder = async ({ orderId, detailedOrder }: PrintOrderProps) => {
    try {
      setIsLoading(true);
      const response = detailedOrder || (await getOrder(orderId));

      // Read ticket type from localStorage (for web printing)
      const ticketType = (localStorage.getItem('printTicketType') as 'normal' | 'double') || 'normal';

      const pdf =
        ticketType === 'double'
          ? await generateDoublePdf(
              commerce,
              response.pedido,
              response.productos,
              commerce?.config_form_entrega?.referencias?.label || 'Referencias',
            )
          : await generatePdf(
              commerce,
              response.pedido,
              response.productos,
              commerce?.config_form_entrega?.referencias?.label || 'Referencias',
            );

      pdf.print();
    } catch {
      toast.error('Error al obtener los detalles del pedido o el pedido no existe');
    } finally {
      setIsLoading(false);
    }
  };

  return { printOrder, isLoading };
};
